export default function mobilecheck() {
  let check = (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);

  console.log(`Mobile: ${check}`)
  return check;
}
